import { ROLES } from "../constants";

const getTitleMenuMessage = (t, userRole) => [
  {
    name: t("wellness-quiz-title"),
    linkForRoute: "wellness-quiz",
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) ||
      userRole?.includes(ROLES.MANAGER) ||
      userRole?.includes(ROLES.NUTRITIONIST)
        ? true
        : false,
  },
  {
    name: t("changelog"),
    linkForRoute: "changelog",
    allowedRoles:
      userRole.includes(ROLES.ADMIN) || userRole.includes(ROLES.MANAGER)
        ? true
        : false,
  },
];

export { getTitleMenuMessage };
